/** Product screenshot — plain image only (no card, border, shadow, or mat). */
export function Shot({ src, alt, className = "" }: { src: string; alt: string; className?: string }) {
  return (
    <img
      src={src}
      alt={alt}
      className={`block h-auto w-full ${className}`.trim()}
      decoding="async"
    />
  );
}
